export default __webpack_public_path__ + "static/media/ISKO_CLASS-9_SYLLABUS.fc01cf2f.pdf";